import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Card.scss';

const Card = ({ children, className, style }) => {
  const renderMissingChildError = (expectedComponent) => (
    console.error(`${expectedComponent} missing as a child of <Card />`)
  );

  const childTypes = React.Children.map(children, children => children.type);
  if (!childTypes.includes(Header)) {
    renderMissingChildError('<CardHeader />');
  }

  if (!childTypes.includes(Body)) {
    renderMissingChildError('<CardBody />');
  }

  if (!childTypes.includes(Footer)) {
    renderMissingChildError('<CardFooter />');
  }

  return (
    <div className={classnames(className, styles.container)} style={style}>
      {children}
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

Card.defaultProps = {
  className: '',
  style: {},
};

export { Card };

const Header = ({ children, className, style }) => (
  <div className={classnames(className, styles.header)} style={style}>
    {children}
  </div>
);

Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

Header.defaultProps = {
  className: '',
  style: {},
};

export { Header as CardHeader };

const Body = ({ children, className, style }) => (
  <div className={classnames(className, styles.body)} style={style}>
    {children}
  </div>
);

Body.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

Body.defaultProps = {
  className: '',
  style: {},
};

export { Body as CardBody };

const Footer = ({ children, className, style }) => (
  <div className={classnames(className, styles.footer)} style={style}>
    {children}
  </div>
);

Footer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

Footer.defaultProps = {
  className: '',
  style: {},
};

export { Footer as CardFooter };
